import React from "react";
import Slider from "react-slick";
import "./FeaturesCarousel.css";

const FeaturesCarousel = ({items,sliderSettings}) => {

  return (
    <div className="container-fluid my-4 position-relative overflow-hidden" style={{ maxWidth: "1200px" }}>
      <Slider {...sliderSettings}>
        {items.map((item, idx) => {
          const hasIcon = !!item.icon;
          const hasText = !!item.text;
          const hasImage = !!item.image;
          const single = (hasIcon && !hasText && !hasImage) ||
                         (hasImage && !hasText && !hasIcon) ||
                         (hasText && !hasIcon && !hasImage);

          return (
            <div
              key={idx}
              className={`d-flex align-items-center justify-content-center ${
                single ? "justify-content-center align-items-center gap-2" : "gap-2"
              }`}
              style={{ width: "100%" }}
            >
              {hasIcon && (
                <span
                //  className={single ? "w-100 text-center" : ""}
                >
                  {item.icon}
                </span>
              )}

              {hasImage && (
               <span
               //  className={single ? "w-100 text-center" : ""}
               >
                  <img
                    src={item.image}
                    alt="feature"
                    className="imgageWidth"
                  />
                </span>
              )}
              {hasText && (
                <span
                //  className={single ? "w-100 text-center" : ""}
                >
                  {item.text}
                </span>
              )}
            </div>
          );
        })}
      </Slider>

      {/* Gradient overlays */}
      <div className="fade-left"></div>
      <div className="fade-right"></div>
    </div>
  );
};

export default FeaturesCarousel;
